import React, { useEffect, useState } from 'react';
import { Replacement } from '../../../interface';
import { OilVolumesService } from '../../OilVolumesService';
import localesReplacement from "../../../utils/localesReplacement";
import Loading from '../../Loading';
import { getProduct } from '../../../services';
import DOMPurify from 'dompurify';
import classnames from 'classnames/bind';
import style from './index.module.scss';
import { useSelector } from 'react-redux';

interface IProps {
  notes: Array<string>;
  replacements: Replacement;
}

const cx = classnames.bind(style);

export const FailedRecommendation = (props: IProps) => {
  const {
    notes,
    replacements
  } = props;
  const [message, setMessage] = useState('');
  const countryCode = localStorage.countryCode;
  const loadSpecialProduct = async () => {
    let response;    
    if (
      !['AUS', 'NZL'].includes(countryCode)
        || (['AUS', 'NZL'].includes(countryCode) && !props.notes || props?.notes?.length === 0)
    ) {
      response = await getProduct(99999);
      if (response.status === 200) {
	setMessage(response?.data?.description);
      }
      else {
	setMessage(localesReplacement(replacements, "No recommended products for this vehicle."));
      }
    }
  };
  useEffect(() => {
    loadSpecialProduct();
  }, [countryCode]);
  
  return (
    <>
      {!message && props?.notes?.length === 0 && <Loading />}
      {(message || props?.notes?.length > 0) && (
        <div className={cx('no-content')}>
          <div
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(message) }}
          ></div>
          <div>
            <br />
            <OilVolumesService
              notes={notes ? notes : []}
              withoutMoreLink={true}
              replacements={replacements}
            />
          </div>
        </div>
      )}
    </>
  );
};
